import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { withStyles } from '@material-ui/core/styles';

import Button from 'fuse-ui/components/Button';
import Divider from 'fuse-ui/components/Divider';
import MuiList from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListSubheader from '@material-ui/core/ListSubheader';
import Typography from 'fuse-ui/components/Typography';

const styles = theme => ( {
    buttonEditRoot: {
        '&:hover, &:focus': {
            backgroundColor: 'transparent',
            boxShadow: 'none'
        },
        backgroundColor: 'transparent',
        justifySelf: 'end',
        minWidth: 0,
        padding: 0,
    },
    dividerMargin: {
        marginBottom: 0,
        marginLeft: theme.spacing.unit * ( -2 ),
        marginRight: theme.spacing.unit * ( -2 ),
        marginTop: 0,
    },
    dividerNoMargin: {
        marginBottom: 0,
        marginLeft: theme.spacing.unit * ( -3 ),
        marginRight: theme.spacing.unit * ( -3 ),
        marginTop: 0,
    },
    editDividerNoMargin: {
        marginBottom: 0,
        marginLeft: theme.spacing.unit * ( -3 ),
        marginRight: theme.spacing.unit * ( -3 ),
        marginTop: 0,
    },
    listItemEditRoot: {
        display: 'grid',
        gridTemplateColumns: '55% 15% 15% 15%',
        gridTemplateRows: 'minmax(36px, max-content)',
        padding: `0 ${theme.spacing.unit * 2}px`,
    },
    listItemRoot: {
        display: 'grid',
        gridTemplateColumns: '70% 30%',
        gridTemplateRows: 'minmax(36px, max-content)',
        padding: 0,
    },
    listPadding: {
        marginBottom: `${theme.spacing.unit * 2}px`,
    },
    listRoot: {
        backgroundColor: theme.palette.background.paper,
        paddingTop: theme.spacing.unit / 2
    },
    senderStatusHeader: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center'
    },
} );

const listTypeMap = {
    domain: {
        capitalized: 'Domain',
        plural: 'domains',
    },
    sender: {
        capitalized: 'Sender',
        plural: 'senders',
    },
};

const List = ( { classes, listLength, editMode, onEdit, type, children } ) => {
    return (
        <MuiList data-automation-id="right-pane-list" classes={{
            root: cx( classes.listRoot, { [ classes.listPadding]: !editMode } )
        }}>
            <ListSubheader disableGutters>
                <ListItem classes={{ root: classes.listItemRoot }} component="div">
                    <Typography data-automation-id="list-count">{listLength} {listTypeMap[type].plural}</Typography>
                    {
                        !editMode &&
                        ( <Button
                            data-automation-id="edit-button"
                            className={classes.buttonEditRoot}
                            variant="text"
                            onClick={onEdit}
                        >
                            Edit
                        </Button> )
                    }
                </ListItem>
                <Divider className={editMode ? classes.editDividerNoMargin : classes.dividerNoMargin}/>
                <ListItem
                    classes={{ root: editMode ? classes.listItemEditRoot : classes.listItemRoot }}
                    component="div"
                    divider={true}
                >
                    <Typography variant="overline">{!editMode && listTypeMap[type].capitalized}</Typography>
                    { editMode && <div/>}
                    <Typography className={cx( { [classes.senderStatusHeader]: editMode } )} variant="overline">
                        Sender Status
                    </Typography>
                </ListItem>
                {
                    editMode &&
                    ( <ListItem classes={{ root: classes.listItemEditRoot }} component="div" divider={true}>
                        <Typography variant="overline">{listTypeMap[type].capitalized}</Typography>
                        <Typography className={classes.senderStatusHeader} variant="overline" align="center">
                            Verified
                        </Typography>
                        <Typography className={classes.senderStatusHeader} variant="overline" align="center">
                            Uncertain
                        </Typography>
                        <Typography className={classes.senderStatusHeader} variant="overline" align="center">
                            Rejected
                        </Typography>
                    </ListItem> )
                }
            </ListSubheader>
            { children }
        </MuiList>
    );
};

List.propTypes = {
    children: PropTypes.arrayOf( PropTypes.element ),
    classes: PropTypes.object,
    data: PropTypes.arrayOf(
        PropTypes.shape( {
            countsByDomain: PropTypes.object,
            id: PropTypes.string,
            name: PropTypes.string,
            url: PropTypes.string,
            verified: PropTypes.bool,
        } )
    ),
    editMode: PropTypes.bool,
    listLength: PropTypes.number,
    onEdit: PropTypes.func,
    onSelection: PropTypes.func,
    type: PropTypes.oneOf( ['domain', 'sender'] ).isRequired
};

List.defaultProps = {
    editMode: false,
};

export default withStyles( styles )( List );
